import {
  GET_PIN_FOR_AUTHORIZE,
  GET_PIN_FOR_AUTHORIZE_LOADED,
  GET_PIN_FOR_AUTHORIZE_ERROR,
  GET_CODE_OF_AUTHORIZE,
  GET_CODE_OF_AUTHORIZE_LOADED,
  GET_CODE_OF_AUTHORIZE_ERROR,
  REGISTER_PHONE,
  REGISTER_PHONE_LOADED,
  REGISTER_PHONE_ERROR,
  SET_FORM_PHONE_NUMBER_REQUEST,
  GO_TO_URL_TO_SUBSCRIPTION,
  SET_FORM_PIN_NUMBER_REQUEST,
  VALID_INPUT_PHONE,
  VALID_INPUT_PIN,
  EDIT_PHONE_NUMBER,
  SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  SET_FORM_REGISTER_REQUEST,
  BOOTSTRAP_DATA,
  LOADING_ON,
  LOADING_OFF,
  SUBSCRIPTION_PLAN
} from './constants';

import {
  formatPhoneNumberInternational
} from '../../utils';


export const bootstrapData = (data) => ({
  type: BOOTSTRAP_DATA,
  data
})

export const setPropsFormPhoneNumerRequest = (loading = 0, subheader = '') => ({
  type: SET_FORM_PHONE_NUMBER_REQUEST,
  props: {
    header: 'Ingrese su número de celular',
    subheader,
    dangerAlert: '',
    placeholder: 'xxxxxxxxx',
    btncolor: 'primary',
    btntext: 'CONTINUAR',
    isLoading: loading
  }
});

export const setPropsFormRegisterRequest = (loading = 0) => ({
  type: SET_FORM_REGISTER_REQUEST,
  props: {
    header: 'Seleccione un plan de suscripción',
    subheader: '',
    dangerAlert: 'El número ingresado no está registrado al producto.',
    checkboxText: 'Términos y condiciones',
    placeholder: 'xxxxxxxxx',
    btncolor: 'primary',
    btntext: 'CONTINUAR',
    isLoading: loading,
    showBackButton: true,
    showSubscriptionPlan: true,
  }
});

export const setPropsFormPinRequest = () => ({
  type: SET_FORM_PIN_NUMBER_REQUEST,
  props: {
    header: 'Por favor, ingrese el código que recibió por SMS',
    subheader: '',
    dangerAlert: '',
    placeholder: '____',
    btncolor: 'primary',
    btntext: 'Continuar'
  }
});

export const _onChangeInputPhone = (e) => ({
  type: VALID_INPUT_PHONE,
  phoneNumber: formatPhoneNumberInternational(e.target.value.substring(0, 9).split()
    .filter((n) => (n.substring(0, 1) === '0' ? '' : n))
    .toString()
    .match(/\d+/g))
});

export const _onChangeInputPin = (e) => ({
  type: VALID_INPUT_PIN,
  pinNumber: e.target.value.substring(0, 4).match(/\d+/g)
});

export const _getPinForAuthorize = (data) => ({
  type: GET_PIN_FOR_AUTHORIZE,
  data
});

export const _getPinForAuthorizeLoaded = (data) => ({
  type: GET_PIN_FOR_AUTHORIZE_LOADED,
  data
});

export const _getPinForAuthorizeError = (error) => ({
  type: GET_PIN_FOR_AUTHORIZE_ERROR,
  error
});

export const _registerPhone = (data) => ({
  type: REGISTER_PHONE,
  data
});

export const _registerPhoneLoaded = (data) => ({
  type: REGISTER_PHONE_LOADED,
  data
});

export const _registerPhoneError = (error) => ({
  type: REGISTER_PHONE_ERROR,
  error
});

export const _getCodeOfAuthorize = () => ({
  type: GET_CODE_OF_AUTHORIZE
});

export const _getCodeOfAuthorizeLoaded = (data) => ({
  type: GET_CODE_OF_AUTHORIZE_LOADED,
  data
});

export const _getCodeOfAuthorizeError = (error) => ({
  type: GET_CODE_OF_AUTHORIZE_ERROR,
  error
});

export const _goToUrlToSubscription = (url) => ({
  type: GO_TO_URL_TO_SUBSCRIPTION,
  url
});

export const _editPhoneNumber = (phoneNumber) => ({
  type: EDIT_PHONE_NUMBER,
  phoneNumber
});

export const _showMessageWithoutSubscription = ({ subscriptionUri }) => ({
  type: SHOW_MESSAGE_WITHOUT_SUBSCRIPTION,
  subscriptionUri
});

export const _loadingOn = () => ({
  type: LOADING_ON
});

export const _loadingOff = () => ({
  type: LOADING_OFF
});

export const _onChangeSubscriptionPlan = (e) => {
  return {
    type: SUBSCRIPTION_PLAN,
    subscriptionPlan: e ? e.target.value : ""
  }
};

export default {
  setPropsFormPhoneNumerRequest,
  setPropsFormPinRequest,
  _onChangeInputPhone,
  _getPinForAuthorize,
  _getPinForAuthorizeLoaded,
  _getPinForAuthorizeError,
  _registerPhone,
  _registerPhoneLoaded,
  _registerPhoneError,
  _goToUrlToSubscription,
  _showMessageWithoutSubscription,
  _loadingOn,
  _loadingOff,
  _onChangeSubscriptionPlan
};
